/* eslint @typescript-eslint/no-explicit-any: 0 */

import { useEffect, useState } from 'react';

const useWindowSize = (windowObject: any) => {
  const [dimensions, setDimensions] = useState({
    height: windowObject.visualViewport
      ? windowObject.visualViewport.height
      : windowObject.innerHeight,
    width: windowObject.visualViewport
      ? windowObject.visualViewport.width
      : windowObject.innerWidth
  });

  useEffect(() => {
    const handleResize = () => {
      dimensions.width !== windowObject.innerWidth &&
        setDimensions({
          height: windowObject.innerHeight,
          width: windowObject.innerWidth
        });
    };

    windowObject.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return dimensions;
};

export default useWindowSize;
